(ns app.front.view.group.admin.template
  (:require [app.domain.inspection.model :as inspection-model]
            [app.domain.planning-report.model :as planning-report-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.file.download :as file-download]
            [app.front.ui :as ui]
            [app.front.ui.dnd :as dnd]
            [app.front.ui.editable-attr :as ui-edit-attr]
            [app.front.ui.inline-editable :as inline-editable]
            [app.front.ui.template-editor :as template-editor]
            [app.front.ui.text-editor :as text-editor]
            [app.front.util :refer [for-frag]]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.fees.bill.template :as bill-template]
            [app.front.view.group.admin.fees.receipt.template :as fee-receipt-template]
            [app.front.view.group.admin.inspections.order-template :as order-template]
            [app.front.view.group.admin.inspections.pdf-template-editor :as pdf-template-editor]
            [app.front.view.group.admin.letter.template-editor :as letter-template-editor]
            [app.front.view.group.admin.licence-revocation-letter-template-editor :as licence-revocation-letter-template-editor]
            [app.front.view.group.admin.meeting-agenda-template-editor :as meeting-agenda-template-editor]
            [app.front.view.group.admin.package-template-editor :as package-template-editor]
            [app.front.view.group.admin.public-notice-template-editor :as public-notice-template-editor]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.admin.templates.subs :as template-subs]
            [app.front.view.group.admin.verdict-template :as vt]
            [app.front.view.group.admin.verdict-template.edit :as verdict-template-edit]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::prepare-template-for-edit
  (fn [{:keys [db]} _]
    {:db (-> db
             text-editor/clear-external-edit-state
             pdf-template-editor/clear-cache)}))

(rf/reg-event-fx ::update-report-template
  (fn [_ [_ group-id template-id updates]]
    {:comm/command {:command    :group/update-planning-report-template
                    :method     :post
                    :data       (merge {:group-id    group-id
                                        :template-id template-id}
                                       updates)
                    :notify     {:success ""}
                    :on-success [::entities/override-entity-db]}}))


(rf/reg-event-fx ::reorder-sections
  (fn [_ [_ template-id from to]]
    {:comm/command {:command    :group/reorder-verdict-template-sections
                    :method     :post
                    :data       {:template-id template-id
                                 :sections    (dnd/ordering-tx-for-entity from to)}
                    :on-success [::entities/apply-changes]}}))

(rf/reg-event-fx ::navigate-to-template
  (fn [_ [_ group-id template-id target-template-id & resp]]
    {:dispatch-n [(into [::entities/apply-changes resp])
                  [:route/replace {:route  :view/group.admin.template
                                   :params {:group-id    group-id
                                            :template-id (or target-template-id template-id)}}]]}))

(rf/reg-event-fx ::set-template-replacement
  (fn [_ [_ group-id template-id target-template-id]]
    {:comm/command {:command    :group/replace-template
                    :method     :post
                    :data       (p/assoc-if (util/mmap group-id template-id)
                                            :target-template-id target-template-id)
                    :on-success [::navigate-to-template group-id template-id target-template-id]}}))

(rf/reg-sub ::editing-template-name? :-> ::editing-template-name?)

(rf/reg-event-db ::edit-template-name
  (fn [db [_ editing?]]
    (assoc db ::editing-template-name? editing?)))


(defmulti
  ^{:arglists '([ctx type template])}
  render-template
  "Accepts a context and template. Returns a DOM hierarchy in hiccup format."
  (fn [_ type template]
    (or (:entity/type template)
        type)))


(defmethod render-template :default [_ type template]
  (throw (js/Error (str "No renderer for template type: " (or (:entity/type template) type)))))


(defn- sub-template-editor [{:keys [template tr read-only? title-key group-id id images prop variables]} children]
  [template-editor/editor
   (-> {:html-template template
        :read-only?    read-only?
        :tr            tr
        :title         (tr [title-key])
        :html-only?    true
        :on-save       #(>evt [::update-report-template
                               group-id
                               id
                               {prop %}])
        :placeholders  variables
        :images        images
        :small?        true}
       (text-editor/with-external-edit-state prop))
   children])


(defmethod render-template :entity.type/planning-draft-report-template [{:keys [tr group-id images inherited? replace-template]} _ template]
  (let [{:planning-draft-report.template/keys
         [html-template
          print-css
          form-issue-snippet
          no-form-issues-snippet
          attachment-issue-snippet
          no-attachment-issues-snippet
          condition-snippet
          closed-condition-snippet
          no-conditions-snippet]
         :planning-report.template/keys
         [property-snippet
          topic-snippet
          comment-snippet
          no-topics-snippet]
         id :db/id}                           template]
    [template-editor/editor
     (-> {:html-template    html-template
          :replace-template replace-template
          :print-css        print-css
          :read-only?       inherited?
          :tr               tr
          :on-save          (fn [html css]
                              (>evt [::update-report-template
                                     group-id
                                     id
                                     {:planning-draft-report.template/html-template (or html "")
                                      :planning-draft-report.template/print-css     (or css "")}]))
          :title            (tr [:planning-reports/draft-report-template])
          :preview-url      (file-download/download-href
                              :group/generate-planning-draft-report-template-preview-pdf
                              {:group-id    group-id
                               :template-id id})
          :placeholders     planning-report-model/draft-report-template-variables
          :images           images}
         (text-editor/with-external-edit-state id))
     [:<>
      [sub-template-editor (util/mmap {:template   property-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/property-snippet
                                       :prop       :planning-report.template/property-snippet
                                       :variables  planning-report-model/properties-snippet-variables}
                                      tr group-id images id)]
      [sub-template-editor (util/mmap {:template   form-issue-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/form-issue-snippet
                                       :prop       :planning-draft-report.template/form-issue-snippet
                                       :variables  planning-report-model/form-issue-snippet-variables}
                                      tr group-id images id)]
      [sub-template-editor (util/mmap {:template   no-form-issues-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/no-form-issues-snippet
                                       :prop       :planning-draft-report.template/no-form-issues-snippet}
                                      tr group-id images id)]
      [sub-template-editor (util/mmap {:template   attachment-issue-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/attachment-issue-snippet
                                       :prop       :planning-draft-report.template/attachment-issue-snippet
                                       :variables  planning-report-model/attachment-issue-snippet-variables}
                                      tr group-id images id)]
      [sub-template-editor (util/mmap {:template   no-attachment-issues-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/no-attachment-issues-snippet
                                       :prop       :planning-draft-report.template/no-attachment-issues-snippet}
                                      tr group-id images id)]
      [sub-template-editor (util/mmap {:template   condition-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/condition-snippet
                                       :prop       :planning-draft-report.template/condition-snippet
                                       :variables  planning-report-model/condition-snippet-variables}
                                      tr group-id images id)]
      [sub-template-editor (util/mmap {:template   closed-condition-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/closed-condition-snippet
                                       :prop       :planning-draft-report.template/closed-condition-snippet
                                       :variables  planning-report-model/closed-condition-snippet-variables}
                                      tr group-id images id)]
      [sub-template-editor (util/mmap {:template   no-conditions-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/no-conditions-snippet
                                       :prop       :planning-draft-report.template/no-conditions-snippet}
                                      tr group-id images id)]
      [sub-template-editor (util/mmap {:template   topic-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/topic-snippet
                                       :prop       :planning-report.template/topic-snippet
                                       :variables  planning-report-model/topic-snippet-variables}
                                      tr group-id images id)
       [sub-template-editor (util/mmap {:template   comment-snippet
                                        :read-only? inherited?
                                        :title-key  :planning-reports/comment-snippet
                                        :prop       :planning-report.template/comment-snippet
                                        :variables  planning-report-model/comment-snippet-variables}
                                       tr group-id images id)]]

      [sub-template-editor (util/mmap {:template   no-topics-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/no-topics-snippet
                                       :prop       :planning-report.template/no-topics-snippet}
                                      tr group-id images id)]]]))


(defmethod render-template :entity.type/planning-final-report-template [{:keys [tr group-id images inherited? replace-template]} _ template]
  (let [{:planning-final-report.template/keys
         [html-template
          print-css
          condition-snippet
          closed-condition-snippet
          no-conditions-snippet]
         :planning-report.template/keys
         [property-snippet
          topic-snippet
          comment-snippet
          no-topics-snippet]
         id :db/id}                           template]
    [template-editor/editor
     (-> {:html-template    html-template
          :read-only?       inherited?
          :replace-template replace-template
          :print-css        print-css
          :tr               tr
          :on-save          (fn [html css]
                              (>evt [::update-report-template
                                     group-id
                                     id
                                     {:planning-final-report.template/html-template (or html "")
                                      :planning-final-report.template/print-css     (or css "")}]))
          :title            (tr [:planning-reports/final-report-template])
          :preview-url      (file-download/download-href
                              :group/generate-planning-final-report-template-preview-pdf
                              {:group-id    group-id
                               :template-id id})
          :placeholders     planning-report-model/final-report-template-variables
          :images           images}
         (text-editor/with-external-edit-state id))
     [:<>
      [sub-template-editor (util/mmap {:template   property-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/property-snippet
                                       :prop       :planning-report.template/property-snippet
                                       :variables  planning-report-model/properties-snippet-variables}
                                      tr group-id images id)]
      [sub-template-editor (util/mmap {:template   condition-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/condition-snippet
                                       :prop       :planning-final-report.template/condition-snippet
                                       :variables  planning-report-model/condition-snippet-variables}
                                      tr group-id images id)]
      [sub-template-editor (util/mmap {:template   closed-condition-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/closed-condition-snippet
                                       :prop       :planning-final-report.template/closed-condition-snippet
                                       :variables  planning-report-model/closed-condition-snippet-variables}
                                      tr group-id images id)]
      [sub-template-editor (util/mmap {:template   no-conditions-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/no-conditions-snippet
                                       :prop       :planning-final-report.template/no-conditions-snippet}
                                      tr group-id images id)]
      [sub-template-editor (util/mmap {:template   topic-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/topic-snippet
                                       :prop       :planning-report.template/topic-snippet
                                       :variables  planning-report-model/topic-snippet-variables}
                                      tr group-id images id)
       [sub-template-editor (util/mmap {:template   comment-snippet
                                        :read-only? inherited?
                                        :title-key  :planning-reports/comment-snippet
                                        :prop       :planning-report.template/comment-snippet
                                        :variables  planning-report-model/comment-snippet-variables}
                                       tr group-id images id)]]
      [sub-template-editor (util/mmap {:template   no-topics-snippet
                                       :read-only? inherited?
                                       :title-key  :planning-reports/no-topics-snippet
                                       :prop       :planning-report.template/no-topics-snippet}
                                      tr group-id images id)]]]))

(defn rename-template [template-name group-id template-id tr]
  [inline-editable/popup-wrapper
   {:tr    tr
    :title (tr [:template-editor/template-name])}
   [inline-editable/text-field-confirm
    {:tr         tr
     :input-opts {:auto-focus    true
                  :default-value template-name}
     :on-confirm (fn [value]
                   (>evt [::verdict-template-edit/rename group-id template-id value])
                   (>evt [::edit-template-name false]))
     :on-cancel  #(>evt [::edit-template-name false])}]])

(defn template-name [{{:verdict.template/keys [name]
                       {group-id :db/id}      :domain/authority-group
                       template-id            :db/id}                 :template
                      superdomain                                     :superdomain
                      inherited?                                      :inherited?
                      tr                                              :tr}]
  (if (ff/enabled? :feature-flag.id/replace-editable-attr)
    [:<>
     [:h2.flex.items-center.justify-between.w-full.pt-1 (cond-> name inherited? (str " (" (:group/name superdomain) ")"))
      (when-not inherited?
        [:div.relative
         (if (<sub [::editing-template-name?])
           [rename-template name group-id template-id tr]
           [cc/button {:kind             :ghost
                       :icon             i/pen
                       :icon-position    :right
                       :class-name       "bottom-0 max-h-4"
                       :size             :small
                       :icon-description (tr [:edit])
                       :on-click         #(>evt [::edit-template-name true])} (tr [:edit])])])]]
    [ui-edit-attr/editable-attr {:value          name
                                 :tr             tr
                                 :text-container :h2.mb-0
                                 :on-change      (when-not inherited?
                                                   #(>evt [::verdict-template-edit/rename
                                                           group-id
                                                           template-id
                                                           %]))}]))


(defmethod render-template :entity.type/verdict-template [{:keys [tr inherited? group-id superdomain superdomain-template] :as context} _ template]
  (r/with-let [*rearranging? (r/atom false)]
    (let [used-in-express (<sub [::verdict-template-edit/template-used-in-express-issuance? (:db/id template)])]
      [:section {:key (:db/id template)}
       [template-name (util/mmap inherited? template tr superdomain superdomain-template)]
       (when used-in-express
         [ui/help (tr [:verdict.template/express-issuance-template-restriction])])
       (cc/toggle {:id         (str "enabled-" (:db/id template))
                   :class-name "mb-4"
                   :disabled   used-in-express
                   :toggled    (if inherited?
                                 (-> (<sub [::gas/group-inherited-template-ids]) (contains? (:db/id template)))
                                 (->> template (du/in-state? :verdict-template.state/disabled) not))
                   :label-text (tr [:admin/enable-template])
                   :on-toggle  #(if inherited?
                                  (>evt [::verdict-template-edit/set-inherited-available
                                         group-id
                                         (:db/id template)
                                         %1])
                                  (>evt [::verdict-template-edit/set-enabled
                                         group-id
                                         (:db/id template)
                                         %1]))})
       [:h3.mt-4 (tr [:verdict.template/parts])
        (when-not inherited?
          (cc/button
            {:on-click   #(swap! *rearranging? not)
             :size       :small
             :class-name "float-right"
             :kind       (if @*rearranging? :secondary :primary)}
            (if @*rearranging? (tr [:done]) (tr [:reorder-short]))))]
       (let [sections (<sub [::verdict-template-edit/sections (:db/id template)])
             ctx      (update context :read-only? #(or % inherited?))] (if @*rearranging?
                                                                         [dnd/wrap-dnd
                                                                          {:id         (str "template-sections-dnd-" (:db/id template))
                                                                           :items      sections
                                                                           :on-reorder #(>evt [::reorder-sections (:db/id template) %1 %2])}
                                                                          (fn [{:keys [sorted augment-target-props augment-draggable-props]}]
                                                                            (for-frag [section sorted]
                                                                              [:div.verdict-template-page.flex.justify-between
                                                                               (augment-target-props {} section)
                                                                               [:span
                                                                                (vt/section-title tr section)
                                                                                (when-let [lang (:entity/language section)]
                                                                                  [:span.ml-1.font-mono "(" lang ")"])]
                                                                               [:div.inline-block
                                                                                (augment-draggable-props {} section)
                                                                                (cc/icon {:icon        i/draggable
                                                                                          :description (tr [:reorder])})]]))]
                                                                         (for-frag [section sections]
                                                                           ^{:key (:db/id section)}
                                                                           [vt/render ctx section])))
       (when-not inherited?
         [verdict-template-edit/add-top-level-section {:template-id (:db/id template)}])])))


(defmethod render-template :entity.type/receipt-template [{:keys [tr inherited? group-id replace-template]} _ template]
  (fee-receipt-template/view tr group-id template inherited? replace-template))

(defmethod render-template :entity.type/bill-pdf-template [{:keys [tr group-id inherited? replace-template]} _ template]
  (bill-template/view tr group-id template inherited? replace-template))

(defmethod render-template :entity.type/inspection-pdf-template [{:keys [tr group-id inherited?]} _ template]
  (pdf-template-editor/view tr group-id template inherited?))

(defmethod render-template :entity.type/order-template [{:keys [tr inherited? group-id]} _ template]
  (order-template/view tr group-id template inherited?))

(defmethod render-template :entity.type/public-notice-template [{:keys [tr group-id inherited? replace-template]} _ template]
  (public-notice-template-editor/view tr group-id template inherited? replace-template))

(defmethod render-template :entity.type/letter-pdf-template [{:keys [tr group-id]} _ template]
  [letter-template-editor/view tr group-id template])

(defmethod render-template :entity.type/licence-revocation-letter-template [{:keys [tr group-id inherited? replace-template]} _ template]
  [licence-revocation-letter-template-editor/view tr group-id template inherited? replace-template])

(defmethod render-template :entity.type/package-pdf-template [{:keys [tr group-id inherited? permit-type]} _ template]
  [package-template-editor/view tr group-id permit-type template inherited?])

(defmethod render-template :entity.type/meeting-agenda-template [{:keys [tr group-id]} _ template]
  [meeting-agenda-template-editor/view tr group-id template])

(defn new-template-breadcrumb [{:keys [tr match]}]
  (let [params (-> match :parameters :path)
        type   (->> match :parameters :path :template-type name (keyword "entity.type"))]
    [:view/group.admin.template.new
     params
     (case type
       :entity.type/inspection-pdf-template (tr [:template-editor/add-new-pdf-template])
       :entity.type/order-template (tr [:template-editor/add-new-order-pdf-template])
       :entity.type/package-pdf-template (tr [:template-editor/add-new-package-pdf-template])
       :entity.type/meeting-agenda-template (tr [:template-editor/add-new-meeting-agenda-template])
       (tr [type]))]))

(defn- template-type-from-match [match]
  (let [params      (-> match :parameters :path)
        template-id (:template-id params)]
    (or (some->> params :template-type name (keyword "entity.type"))
        (when template-id
          (:entity/type (<sub [::entities/entity template-id]))))))

(defn meeting-grandparent-breadcrumb [{:keys [tr match]}]
  (when (= :entity.type/meeting-agenda-template (template-type-from-match match))
    (let [group-id (-> match :parameters :path :group-id)]
      [:view/group.admin.meetings {:group-id group-id} (tr [:view/group.admin.meetings])])))

(defn template-parent-breadcrumb [{:keys [tr match]}]
  (let [params (-> match :parameters :path)]
    (if (= :entity.type/meeting-agenda-template (template-type-from-match match))
      [:view/group.admin.meeting-templates {:group-id (:group-id params)} (tr [:meeting/template-subtitle])]
      [:view/group.admin.templates params (tr [:view/group.admin.templates])])))

(defn edit-template-breadcrumb [{:keys [tr match]}]
  (let [params   (-> match :parameters :path)
        template (<sub [::entities/entity (-> match :parameters :path :template-id)])
        type     (:entity/type template)]
    [:view/group.admin.template
     params
     (case type
       :entity.type/verdict-template (:verdict.template/name template)
       :entity.type/inspection-pdf-template (:inspection.pdf-template/name template)
       :entity.type/order-template (inspection-model/order-template-name template (<sub [:language]))
       :entity.type/receipt-template (-> (:receipt-template/subtype template) vector tr)
       :entity.type/meeting-agenda-template (:meeting-agenda-template/name template)
       (tr [type]))]))

(defn- get-template [group-id type subtype]
  (if subtype
    (<sub [::template-subs/template-by-subtype group-id subtype])
    (<sub [::template-subs/template group-id type])))

(defn replace-template [tr group-id template-id template-type superdomain]
  (let [template             (<sub [::entities/entity template-id])
        domain-template      (get-template group-id template-type (:receipt-template/subtype template))
        superdomain-template (get-template (:db/id superdomain) template-type (:receipt-template/subtype template))]
    (when (and superdomain-template domain-template)
      (let [checked? (= (:db/id superdomain-template) template-id)]
        [:div.mr-auto.ml-2.mt-2
         [cc/checkbox {:id         (str group-id "-replace-template")
                       :label-text (tr [:group-admin/use-template-from] [(:group/name superdomain)])
                       :checked    checked?
                       :on-change  #(>evt [::set-template-replacement
                                           group-id
                                           (:db/id domain-template)
                                           (when-not checked?
                                             (:db/id superdomain-template))])}]]))))

(defn view [match]
  (let [tr               (<sub [::gas/group-tr])
        template-id      (-> match :parameters :path :template-id)
        template         (<sub [::entities/entity template-id])
        template-type    (or (:entity/type template)
                             (->> match :parameters :path :template-type name (keyword "entity.type")))
        group-id         (-> match :parameters :path :group-id)
        images           (<sub [::gas/verdict-images group-id])
        inherited?       (boolean (some-> template :domain/authority-group :db/id (not= group-id)))
        superdomain      (<sub [::gas/superdomain])
        replace-template (some->> superdomain (replace-template tr group-id template-id template-type))
        context          (util/mmap {:permit-type (-> match :parameters :path :permit-type)}
                                    superdomain inherited? tr group-id images replace-template)]
    [acommon/admin-page
     (util/mmap {:title           (tr [:group-admin/template])
                 :wait-for-group? true}
                match)
     [render-template context template-type template]]))
